import { FormFieldTypes } from "../../../data/formFieldType";

export const InvoiceApprovalData = {
    name: "AdditionalInfo",
    initialState: {
        searchByCompanyName: "",
        searchByApprover: null,
        searchByCertificateNumber: "",
    },
    formFields: [
        {
            id: "searchByCompanyName",
            lable: "Search by Company Name",
            Field_Name: "Search by Company Name",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByCompanyName",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-3",
            },
        },
      
        {
            id: "searchByApprover",
            lable: "Search by Approver",
            Field_Name: "Search by Approver",
            fieldType: FormFieldTypes.SELECT,
            dataField: "searchByApprover",
            fieldSetting: {
                placeholder: "Select",
                options: [],
            },
            style: {
                containerCss: "col-lg-4",
            },
        },
        {
            id: "searchByCertificateNumber",
            lable: "Search by Certificate Number",
            Field_Name: "Search by Certificate Number",
            fieldType: FormFieldTypes.INPUT,
            dataField: "searchByCertificateNumber",
            fieldSetting: {
                placeholder: "",
                allowSpace: true,
            },
            style: {
                containerCss: "col-lg-4 mb-3",
            },
        },
    ],
    formSetting: {
        isViewOnly: false,
    },
};
